// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__ctOXH","tab":"tabs_tab__v16Ec","selected":"tabs_selected__hh4Gc"};